module.exports = __webpack_public_path__ + "static/img/SR.782c8202.png";